<template>
  <div>
    <br />
    <vs-card style="border-radius: 20px">
      <vs-table
        max-items="5"
        pagination
        :data="sensor"
        search
        hoverFlat="false"
      >
        <template slot="header">
          <h3 class="ml-3">Sensor List</h3>
        </template>
        <template slot="thead" align="center">
          <vs-th> </vs-th>
          <vs-th v-for="item in sensorhead" :key="item">
            <div style="width: 100%; text-align: center">
              <vs-row
                ><span>{{ item }}</span>
                <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span
              ></vs-row>
            </div>
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td align="center">
              <vs-row>
                <vs-button
                  icon="add_circle"
                  type="flat"
                  style="border-radius: 20px"
                  >view</vs-button
                >
                <vs-button
                  icon="delete"
                  type="flat"
                  style="border-radius: 20px"
                  color="danger"
                  >Delete</vs-button
                >
              </vs-row>
            </vs-td>

            <vs-td :data="data[indextr].Name" align="center">
              {{ data[indextr].Name }}
            </vs-td>

            <vs-td :data="data[indextr].Serial_Number" align="center">
              {{ data[indextr].Serial_Number }}
            </vs-td>

            <vs-td :data="data[indextr].Type" align="center">
              {{ data[indextr].Type }}
            </vs-td>

            <vs-td :data="data[indextr].Network" align="center">
              {{ data[indextr].Network }}
            </vs-td>

            <vs-td :data="data[indextr].Location" align="center">
              {{ data[indextr].Location }}
            </vs-td>

            <vs-td :data="data[indextr].Active_Status" align="center">
              <!-- {{ data[indextr].Active_Status }} -->
              <vs-icon
                icon="circle"
                color="primary"
                size="21px"
                v-if="data[indextr].Active_Status == 'Active'"
              ></vs-icon>
              <vs-icon
                icon="circle"
                color="grey"
                size="21px"
                v-if="data[indextr].Active_Status != 'Active'"
              ></vs-icon>
            </vs-td>

            <vs-td :data="data[indextr].Signal" align="center">
              <!-- {{ data[indextr].Signal }} -->
              <vs-icon icon="signal_cellular_alt_1_bar" color="primary" v-if="data[indextr].Signal === 'Low'"></vs-icon>
              <vs-icon icon="signal_cellular_alt_2_bar" color="primary" v-if="data[indextr].Signal === 'Medium'"></vs-icon>
              <vs-icon icon="signal_cellular_alt" color="primary" v-if="data[indextr].Signal === 'High'"></vs-icon>
            </vs-td>

            <vs-td :data="data[indextr].Battery" align="center">
              <vs-row>
               
              <vs-icon icon="battery_alert" color="warning" v-if="data[indextr].Battery == 0"></vs-icon>
              <vs-icon icon="battery_0_bar" color="primary" v-if="data[indextr].Battery <= 9 && data[indextr].Battery > 0"></vs-icon>
              <vs-icon icon="battery_1_bar" color="primary" v-if="data[indextr].Battery <= 19 && data[indextr].Battery > 9"></vs-icon>
              <vs-icon icon="battery_2_bar" color="primary" v-if="data[indextr].Battery <= 29 && data[indextr].Battery > 19"></vs-icon>
              <vs-icon icon="battery_3_bar" color="primary" v-if="data[indextr].Battery <= 39 && data[indextr].Battery > 29"></vs-icon>
              <vs-icon icon="battery_4_bar" color="primary" v-if="data[indextr].Battery <= 49 && data[indextr].Battery > 39"></vs-icon>
              <vs-icon icon="battery_5_bar" color="primary" v-if="data[indextr].Battery <= 59 && data[indextr].Battery > 49"></vs-icon>
              <vs-icon icon="battery_6_bar" color="primary" v-if="data[indextr].Battery <= 69 && data[indextr].Battery > 59"></vs-icon>
              <vs-icon icon="battery_full" color="primary"  v-if="data[indextr].Battery  > 69 && data[indextr].Battery > 69"></vs-icon>
              <vs-icon icon="battery_charging_full" color="primary" v-if="data[indextr].Battery == 'Charging'"></vs-icon>
              <span class="mt-1 pt-1" style="color:green"  v-if="data[indextr].Battery != 0">{{ data[indextr].Battery }}<span v-if="typeof data[indextr].Battery === 'number'">%</span></span>
              <span class="mt-1 pt-1" style="color:orange" v-if="data[indextr].Battery == 0">{{ data[indextr].Battery }}<span v-if="typeof data[indextr].Battery === 'number'">%</span></span>
              </vs-row>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sensorhead: [
        "Name",
        "Serial_Number",
        "Type",
        "Network",
        "Location",
        "Active_Status",
        "Signal",
        "Battery",
      ],
      sensor: [
        {
          Name: "Lora Sensor 1",
          Serial_Number: "lora1",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "Active",
          Signal: "Low",
          Battery: 50,
        },
        {
          Name: "Lora Sesnor 2",
          Serial_Number: "lora2",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "inActive",
          Signal: "High",
          Battery: 40,
        },
        {
          Name: "Lora Sesnor 3",
          Serial_Number: "lora3",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "Active",
          Signal: "Medium",
          Battery: 20,
        },
        {
          Name: "Lora Sesnor 4",
          Serial_Number: "lora4",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "Active",
          Signal: "Low",
          Battery: 10,
        },
        {
          Name: "Lora Sesnor 5",
          Serial_Number: "lora5",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "inActive",
          Signal: "Low",
          Battery: 0,
        },
        {
          Name: "Lora Sesnor 6",
          Serial_Number: "lora6",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "inActive",
          Signal: "High",
          Battery: 70,
        },
        {
          Name: "Lora Sesnor 7",
          Serial_Number: "lora7",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "inActive",
          Signal: "Medium",
          Battery: "Charging",
        },
        {
          Name: "Lora Sesnor 8",
          Serial_Number: "lora8",
          Type: "lora",
          Network: "Swift Network",
          Location: "Meeting Room",
          Active_Status: "inActive",
          Signal: "Medium",
          Battery: 69,
        },
      ],
    };
  },
};
</script>

<style></style>
